/*=============================================== AutocompletePage ===============================================*/

import { useState } from "react"
import { Autocomplete } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import {
    frenchCities,
    inputLabel,
    validationObject,
    inputIcon,
    inputBackgroundColor,
    listDirection,
    inputVariants,
    iconBoxicon,
} from "data"

const AutocompletePage = () => {
    const [location, setLocation] = useState<string>("")

    const items: ItemType[] = [
        {
            intro: (
                <>
                    Here, <code>frenchCities</code> is just an array of strings.
                </>
            ),
            content: (
                <Autocomplete
                    items={frenchCities}
                    value={location}
                    setValue={setLocation}
                    label="Search a French city"
                    focusKeys={["Command", "KeyJ"]}
                    showKeys
                />
            ),
            code: 'const [location, setLocation] = useState("")\n\n<Autocomplete\n    items={frenchCities}\n    value={location}\n    setValue={setLocation}\n    label="Search a French city"\n    focusKeys={["Command", "KeyJ"]}\n    showKeys\n/>',
            codeTs: 'const [location, setLocation] = useState<string>("")\n\n<Autocomplete\n    items={frenchCities}\n    value={location}\n    setValue={setLocation}\n    label="Search a French city"\n    focusKeys={["Command", "KeyJ"]}\n    showKeys\n/>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "value",
            type: "string",
            required: true,
        },
        {
            subtitle: "setValue",
            type: "function",
            required: true,
        },
        {
            subtitle: "items",
            type: "array of strings",
            required: true,
        },
        ...inputIcon(),
        {
            subtitle: "iconClear",
            type: "string",
            default: iconBoxicon("x"),
        },
        {
            subtitle: "emptyText",
            intro: "Text showing when search does not return any result.",
            type: "string",
            default: "No result.",
        },
        inputBackgroundColor(),
        listDirection(),
        inputVariants(),
        {
            subtitle: "fuzzyOptions",
            intro: (
                <a
                    href="https://fusejs.io/api/options.html"
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    Find all options here.
                </a>
            ),
            type: "object",
        },
        {
            subtitle: "focusKeys",
            type: "array of strings",
        },
        {
            subtitle: "showKeys",
            intro: (
                <>
                    Only if <code>focusKeys</code> is defined.
                </>
            ),
            type: "boolean",
        },
        ...inputLabel(),
        ...validationObject(),
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default AutocompletePage
